import React from 'react'
import NextHead from 'next/head'

import { BRAND_NAME_TITLE as brand } from 'src/constants/business'
import { buildCanonicalURL } from 'lib/utils/page'
import { getJsonLd } from 'client/components/JsonLd/utils'

import HrefLangs from 'src/comps/HrefLangs'
import { useMarket } from 'src/hooks/useMarket'
import { useS4LContext } from '@s4l/react-context'

interface IHeadProps {
  pathname: string
  city?: string
  totalResults?: string
}

const Head = ({ pathname, city = '', totalResults = '' }: IHeadProps) => {
  const { i18n } = useS4LContext()
  const { subdomain, topdomain, language, market } = useMarket()

  const title = i18n.formatMessage(
    { id: 'page.serp.title-seo' },
    {
      location: city,
      total_results: totalResults,
      brand,
    }
  )
  const description = i18n.formatMessage(
    {
      id: 'page.serp.description',
    },
    { city_name: city, brand }
  )
  const canonicalURL = buildCanonicalURL({ pathname, market, language, subdomain, topdomain })

  return (
    <>
      <NextHead>
        <title>{title}</title>
        <link rel="canonical" href={canonicalURL} />
        <meta name="title" content={`${title}`} />
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <script type="application/ld+json">{getJsonLd(market)}</script>
      </NextHead>
      <HrefLangs pathname={pathname} />
    </>
  )
}

export default Head
